module.exports = __webpack_public_path__ + "img/keder_kieferngruen_ral6028.87a77a8d.jpg";